import { useEffect, useState } from 'react';
import './SuccessStep.css';


interface SuccessStepProps {
    planName: string;
    onReset: () => void;
}

export function SuccessStep({ planName, onReset: _ }: SuccessStepProps) {
    // Confetti logic
    const [particles, setParticles] = useState<number[]>([]);

    useEffect(() => {
        // Create 20 confetti particles
        setParticles(Array.from({ length: 30 }, (_, i) => i));
    }, []);

    return (
        <div className="success-step">
            {/* Background Confetti */}
            {particles.map((i) => (
                <div
                    key={i}
                    className="confetti"
                    style={{
                        left: `${Math.random() * 100}%`,
                        backgroundColor: ['#10b981', '#3b82f6', '#f59e0b', '#ef4444'][Math.floor(Math.random() * 4)],
                        animationDelay: `${Math.random() * 2}s`,
                        animationDuration: `${2 + Math.random() * 3}s`
                    }}
                />
            ))}

            <div className="success-card">
                <div className="success-icon-wrapper">
                    <svg className="success-check" viewBox="0 0 24 24">
                        <path d="M20 6L9 17l-5-5" />
                    </svg>
                </div>

                <div className="plan-badge">
                    {planName} Member
                </div>

                <h1 className="success-title">Welcome to Nostavia!</h1>

                <p className="success-message">
                    Your Concierge manager is assigned and will contact you within 24 hours for next steps.
                </p>
            </div>
        </div>
    );
}
